import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/solicitacao/vistoria';

const surveyEndpoints = {
    finishRequest: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/finalizar/${cdSolicitacao}`, {}),
    cancelRequest: (cdSolicitacao, payload = {}, context = EXTERNAL_CONTEXT) =>
        stipAxios.put(`${context}${BASE_ENDPOINT}/cancelar/${cdSolicitacao}`, payload),
    saveRequest: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/save`, payload),
    saveVehicleSurvey: (cdSolicitacao, payload) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/vistoria-veiculo/save/${cdSolicitacao}`, payload),
    sendSurvey: (cdSolicitacao) => stipAxios.put(`${BASE_ENDPOINT}/enviar/${cdSolicitacao}`),
    sendInspectionReport: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/laudo/${cdSolicitacao}`),
    maxAgeVehicle: (payload, context = EXTERNAL_CONTEXT) => {
        const { cdServico, dePlaca, nuAnoFabricacao, cdSubSistema, deUtilizacao } = payload;
        return stipAxios.post(`${context}${BASE_ENDPOINT}/idade-maxima-vistoria-veiculo`, {
            cdServico,
            dePlaca,
            nuAnoFabricacao,
            cdSubSistema,
            deUtilizacao,
        });
    },
    getSurveyByRequest: (cdSolicitacao) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/solicitacao/${cdSolicitacao}`),
    getSurveyVehicleSituation: (param) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/situacao-vistoria-veiculo`, param),
    getVehiclesSituation: (cdVistoriaVeiculo) =>
        stipAxios.put(`${BASE_ENDPOINT}/situacao-vistoria-veiculo/${cdVistoriaVeiculo}`),
    getSystemClassification: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/classificacaosistema`),
    getSubitemComponent: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/subitemcomponente`),
    getDefectClassification: (cdClassificacaoSistema, cdSubitemComponente) =>
        stipAxios.get(
            `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/classificacaodefeito/${cdClassificacaoSistema}/${cdSubitemComponente}`,
        ),
    deleteVehicle: (cdVistoriaVeiculo, cdSolicitacao) =>
        stipAxios.delete(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/veiculo/excluir/${cdVistoriaVeiculo}/${cdSolicitacao}`),
    deleteIrregularity: (cdVistoriaVeiculoIrreg) =>
        stipAxios.delete(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/irregularidade/excluir/${cdVistoriaVeiculoIrreg}`),
};

export default surveyEndpoints;
